// import Ads from '../Pages/Ads';
// import Manager from '../Pages/Manager';
//Admin
import Home from '../Pages/Admin/Home';
import Customer from '../Pages/Admin/Customer';

import AccountAds from '../Pages/Admin/AccountAds';
import FbCampaigns from '../Pages/Admin/FbCampaigns';

//User
import Home2 from '../Pages/User/Home';
import Detail from '../Pages/User/Detail';


//Public
import Login from '../Pages/Login';
import Notfound from '../Pages/NotFound';

//Public Route
const adminRoutes = [
    { path: '/admin', component: Home },
    { path: '/admin/customer/:slug', component: Customer },
    { path: '/account-ads', component: AccountAds },
    { path: '/account-ads/:id', component: FbCampaigns },
];

// User routes
const userRoutes = [
    { path: '/', component: Home2 },
    { path: '/user/detail', component: Detail },
    { path: '/user/profile', component: Home },
];

const publicRoutes = [
    { path: '/login', component: Login, layout: null },
    { path: '/*', component: Notfound },
];
export { publicRoutes, adminRoutes, userRoutes };
